module.exports = __webpack_public_path__ + "static/img/busyImg.99cdc71.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/busyImg.png
// module id = K+gz
// module chunks = 1